import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const Footer3 = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Box
      sx={{
        backgroundColor: '#00b9c4',
        color: 'white',
        px: 2,
        py: 3,
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'center',
        justifyContent: 'space-between',
        textAlign: 'center',
        gap: 2,
      }}
    >
      {/* Center: Contact info */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          flexWrap: 'wrap',
          mx: 'auto',
        }}
      >
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          📞 (305) 364-6100
        </Typography>

        {/* Vertical Divider */}
        <Box
          sx={{
            width: '1px',
            height: '20px',
            backgroundColor: 'white',
            display: { xs: 'none', sm: 'block' },
          }}
        />

        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          ✉️ transportationlist@miamilakes-fl.gov
        </Typography>
      </Box>

      {/* Right: Scroll to top */}
      <IconButton
        onClick={scrollToTop}
        sx={{
          backgroundColor: 'white',
          color: '#00b9c4',
          '&:hover': {
            backgroundColor: '#e0f7fa',
          },
          mt: { xs: 2, md: 0 },
        }}
      >
        <ArrowUpwardIcon />
      </IconButton>
    </Box>
  );
};

export default Footer3;
